import { useState, useEffect } from "react";
import {  useSelector } from "react-redux";
import Styles from "../editScreenStyles.module.css";
import { damageTypes } from "../../../../constants/options";
import { damageKeys, formTypes } from "../../../../constants/keys";

function IncidentDetailsEdit({
  lossCauses,
  fields,
  utilities,
  updateClicked,
  cancelClicked
}) {
  const typeOfClaim = useSelector((state) => state.anonymousForms.typeOfClaim);
  const [theCauses, setTheCauses] = useState([]);

  const {
    createCustomLabelTextArea,
    createSearchableSelect,
    createCustomLabelSelect,
    handleFieldChange
  } = utilities;

  useEffect(() => {
    if (typeOfClaim === formTypes.Auto || typeOfClaim === formTypes.Garage || typeOfClaim === formTypes.Vehicle) {
      setTheCauses([...lossCauses.filter((cause) => cause.Auto)]);
    } else if (typeOfClaim === formTypes.Liability) {
      setTheCauses([...lossCauses.filter((cause) => cause.Liability)]);
    } else if (typeOfClaim === formTypes.Property) {
      setTheCauses([...lossCauses.filter((cause) => cause.Property)]);
    } else if (typeOfClaim === formTypes.Home) {
      if (damageTypes.find(type => type.label === fields.damageType?.value).value === damageKeys.Property) {
        setTheCauses([...lossCauses.filter((cause) => cause.Property)]);
      } else {
        setTheCauses([...lossCauses.filter((cause) => cause.HomeLiability)]);
      }
    }
  }, [typeOfClaim, fields.damageType?.value]);

  useEffect(() => {
    if (
      theCauses?.length > 0 &&
      fields.lossCause.value &&
      !theCauses.find((cause) => cause.FullText === fields.lossCause.value)
    ) {
      handleFieldChange("", fields.lossCause, true, null);
    }
  }, [theCauses]);

  return (
    <div style={{ width: "100%" }}>
      <div className={`${Styles.title} required-field`}>
        Incident Description
      </div>
      
      <div className={Styles.column}>
      {createCustomLabelTextArea(fields.whatHappen, "100%", Styles.textarea, Styles.blockLabel)}
        {typeOfClaim === formTypes.Home && (
          <div style={{ width: "100%", paddingBottom: ".5rem" }}>
            {createCustomLabelSelect(
              fields.damageType,
              damageTypes.map(item => item.label),
              Styles.select,
              Styles.blockLabel
            )}
          </div>
        )}
        <div style={{ width: "100%", paddingBottom: ".5rem" }}>
          {createSearchableSelect(
            fields.lossCause,
            "100%",
            theCauses.map(item => item.FullText),
            false,
            "",
            false,
            true
          )}
        </div>
        <div className={Styles.row}>
          <div className={Styles.buttons}>
            <button
              type="button"
              className={Styles.button}
              onClick={cancelClicked}
            >
              Cancel
            </button>
            <button
              type="button"
              className={Styles.button}
              onClick={updateClicked}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IncidentDetailsEdit;
